import React, { useEffect, useState, useContext } from 'react';
import { db, storage } from '../../../firebase';
import { Link } from 'react-router-dom';
import { collection, getDocs, doc, updateDoc, addDoc,getDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import EditCategorieModal from './EditCategorieModal';
import CreateCategorieModal from './CreateCategorieModal';
import ReactPaginate from 'react-paginate';
import { UserContext } from '../../../contexts/UserContext';

const Categories = () => {
    const [categories, setCategories] = useState([]);
    const [platsCount, setPlatsCount] = useState({});
    const [showEditModal, setShowEditModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [selectedCategorie, setSelectedCategorie] = useState(null);
    const [filterName, setFilterName] = useState(''); // State for filter value
    const { user } = useContext(UserContext);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(0);
    const categoriesPerPage = 10; 

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const categoriesCollection = collection(db, 'categorie');
                const categoriesSnapshot = await getDocs(categoriesCollection);
                const categoriesList = categoriesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setCategories(categoriesList);
            } catch (error) {
                console.error("Error fetching categories: ", error);
            }
        };

        const fetchPlats = async () => {
            try {
                const platsCollection = collection(db, 'food-items');
                const platsSnapshot = await getDocs(platsCollection);
                const platsList = platsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                // Count plats by category
                const countByCategory = {};
                platsList.forEach(plat => {
                    const categorieId = plat.categorie;
                    if (countByCategory[categorieId]) {
                        countByCategory[categorieId]++;
                    } else {
                        countByCategory[categorieId] = 1;
                    }
                });

                setPlatsCount(countByCategory);
            } catch (error) {
                console.error("Error fetching plats: ", error);
            }
        };

        fetchCategories();
        fetchPlats();
    }, []);

    // Filter categories based on filterName
    const filteredCategories = categories.filter(categorie =>
        categorie.nom.toLowerCase().includes(filterName.toLowerCase())
    );

    // Calculate pagination data
    const indexOfLastCategory = (currentPage + 1) * categoriesPerPage;
    const indexOfFirstCategory = indexOfLastCategory - categoriesPerPage;
    const currentCategories = filteredCategories.slice(indexOfFirstCategory, indexOfLastCategory);
    const pageCount = Math.ceil(filteredCategories.length / categoriesPerPage);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleShowEdit = (categorie) => {
        setSelectedCategorie(categorie);
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedCategorie(null);
    };

    const handleSaveCategorie = async (updatedCategorie) => {
        try {
            const categorieDoc = doc(db, 'categorie', updatedCategorie.id);
            await updateDoc(categorieDoc, updatedCategorie);
            setCategories(prevCategories => 
                prevCategories.map(categorie => 
                    categorie.id === updatedCategorie.id ? updatedCategorie : categorie
                )
            );
        } catch (error) {
            console.error("Error updating category: ", error);
        }
    };

    const handleShowCreate = () => {
        setShowCreateModal(true);
    };

    const handleCloseCreateModal = () => {
        setShowCreateModal(false);
    };

    const handleCreateCategorie = async (newCategorie) => {
        try {
            let imageUrl = '';
            if (newCategorie.image) {
                const imageRef = ref(storage, `categories/${newCategorie.image.name}`);
                await uploadBytes(imageRef, newCategorie.image);
                imageUrl = await getDownloadURL(imageRef);
            }
    
            // Récupérer et incrémenter le compteur
            const counterRef = doc(db, 'metadata', 'categorieCounter');
            const counterSnap = await getDoc(counterRef);
            if (!counterSnap.exists()) {
                throw new Error("Le compteur de catégories n'existe pas.");
            }
            const currentValue = counterSnap.data().currentValue;
    
            // Mettre à jour le compteur
            await updateDoc(counterRef, { currentValue: currentValue + 1 });
    
            // Créer la catégorie avec le champ ordre
            const categorieDoc = await addDoc(collection(db, 'categorie'), {
                nom: newCategorie.nom,
                image: imageUrl,
                ordre: currentValue + 1 // Nouvelle valeur incrémentée
            });
    
            // Ajouter l'ID au document
            await updateDoc(categorieDoc, { id: categorieDoc.id });
    
            // Mettre à jour l'état local
            setCategories(prevCategories => [
                ...prevCategories,
                { id: categorieDoc.id, nom: newCategorie.nom, image: imageUrl, ordre: currentValue + 1 }
            ]);
        } catch (error) {
            console.error("Erreur lors de la création de la catégorie : ", error);
        }
    };
    
    

    return (
        <div id="content-wrapper" className="d-flex flex-column ">
            <div id="content">
                <div className="container-fluid">
                    <h1 className="h3 mb-2 text-gray-800">Catégories</h1>
                    <p className="mb-4"></p>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 font-weight-bold title-2">Catégories  {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                <FontAwesomeIcon icon={faPlus} onClick={handleShowCreate} style={{ cursor: 'pointer' }} />
                            )}</h6>
                           <input
                                    type="text"
                                    className="form-control w-25" // Adjust width with Bootstrap utility class
                                    placeholder="Filtrer par nom"
                                    value={filterName}
                                    onChange={(e) => setFilterName(e.target.value)}
                                />
                        </div>
                        <div className="card-body">
                          
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Image</th>
                                            <th>Nom</th>
                                            <th>Total</th>
                                            {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                                <th>Action</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tfoot>
                                        <tr>
                                            <th>Image</th>
                                            <th>Nom</th>
                                            <th>Total</th>
                                            {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                                <th>Action</th>
                                            )}
                                        </tr>
                                    </tfoot>
                                    <tbody>
                                        {currentCategories.map((categorie) => (
                                            <tr key={categorie.id}>
                                                <td>
                                                    {categorie.image && <img src={categorie.image} alt={categorie.nom} style={{ width: '50px', height: '50px' }} />}
                                                </td>
                                                <td>{categorie.nom}</td>
                                                <td>{platsCount[categorie.id] || 0}</td>
                                                {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                                    <td>
                                                        <Link className="btn btn-primary btn-circle btn-sm ml-2" to="#" onClick={() => handleShowEdit(categorie)}>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </Link>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination justify-content-end'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {selectedCategorie && (
                <EditCategorieModal 
                    show={showEditModal} 
                    handleClose={handleCloseEditModal} 
                    categorie={selectedCategorie} 
                    handleSave={handleSaveCategorie} 
                />
            )}
            <CreateCategorieModal 
                show={showCreateModal} 
                handleClose={handleCloseCreateModal} 
                handleCreate={handleCreateCategorie} 
            />
        </div>
    );
};

export default Categories;
